module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAATCAYAAACKsM07AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACkSURBVHgB7ZMxDoJAEEX/zGziNYgn4AbS2HsE72FhYYzH8AraaozewANo4hUsoSADSwdsA2EKCK/4xWv+JvMXGDvk43c7xsr0hgHsIxeOYQTDGPMC50M4uyBdvDAToJrp535IhGQPA6obELsIqgkMcEGreoXSv+YEKygiDFGwXO82Tfd9nLYMPaMjE/loTfyqWjIvR9DjOcGCcrLPliT0Yvw3KADD7x7b8HNpTAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WithdrawalSuccessful/wallet.png
// module id = 9400
// module chunks = 0